import type { CartModel } from '@bytel/leviator';

import { getSessionData, setSessionVariable } from './storage';

interface MixedCartStorageValue {
    data: boolean;
}

const storageKey = 'panierMixte';

export function isMixedCartEnabled(): boolean {
    const value = getSessionData<MixedCartStorageValue>(storageKey);
    return value?.data !== false;
}

export function setMixedCartEnabled(enabled: boolean): void {
    setSessionVariable(storageKey, JSON.stringify({ data: enabled }));
}

export function canUseMixedCart(cart?: CartModel): boolean {
    return isMixedCartEnabled() && Boolean(cart?.isEligibleForMixedCart());
}
